export default __webpack_public_path__ + "static/media/image.epic-labs.9cbe88b1.png";